import { useTranslation } from 'react-i18next';
import { KoobModal, KoobButton } from '@koob/ui';
import KoobTitle from '../../../components/Koob/KoobTitle';
import KoobParagraph from '../../../components/Koob/KoobParagraph';

/**
 * Shown before a distribution that would hand a TO a template whose products it
 * cannot see. Lists every (template, product, TOs) triple the API reported and
 * lets the DMC distribute anyway — the products are not distributed for it,
 * that is out of scope, so this is purely an informed confirmation.
 */
export default function DistributionIncoherenceModal({
  open,
  incoherences = [],
  isBulk = false,
  submitting = false,
  onCancel,
  onConfirm,
}) {
  const { t } = useTranslation('toConnectionRequest');

  return (
    <KoobModal open={open} setOpen={onCancel} widthClass="sm:max-w-2xl">
      <div className="p-5">
        <KoobTitle>{t('distributionCheck.title')}</KoobTitle>

        <KoobParagraph>
          {isBulk
            ? t('distributionCheck.descriptionBulk')
            : t('distributionCheck.descriptionSingle')}
        </KoobParagraph>

        <div className="mt-5 max-h-80 overflow-y-auto">
          <table className="w-full text-left text-sm">
            <thead className="sticky top-0 bg-white">
              <tr className="border-b border-gray-200 text-xs uppercase text-gray-500">
                <th className="py-2 pr-3">{t('distributionCheck.template')}</th>
                <th className="py-2 pr-3">{t('distributionCheck.product')}</th>
                <th className="py-2">{t('distributionCheck.organizations')}</th>
              </tr>
            </thead>
            <tbody>
              {incoherences.map((incoherence) => (
                <tr
                  key={`${incoherence.template.id}_${incoherence.product.type}_${incoherence.product.id}`}
                  className="border-b border-gray-100 align-top"
                >
                  <td className="py-2 pr-3 font-medium text-gray-800">
                    {incoherence.template.name}
                  </td>
                  <td className="py-2 pr-3 text-gray-700">
                    <div>{incoherence.product.name}</div>
                    {incoherence.product.address && (
                      <div className="text-xs text-gray-500">
                        {incoherence.product.address}
                      </div>
                    )}
                  </td>
                  <td className="py-2 text-gray-700">
                    {incoherence.organizations
                      .map((organization) => organization.displayName)
                      .join(', ')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <KoobButton variant="secondary" onClick={onCancel}>
            {t('misc:cancel')}
          </KoobButton>
          <KoobButton
            variant="primary"
            onClick={onConfirm}
            disabled={submitting}
          >
            {t('distributionCheck.confirm')}
          </KoobButton>
        </div>
      </div>
    </KoobModal>
  );
}
